import React from 'react';
import { useLanguage } from './Contexts/LanguageContext';
import './About.css';

// Importeer de SVG-bestanden
import FacebookIcon from './assets/icons/facebook.svg';
import InstagramIcon from './assets/icons/instagram.svg';
import LinkedInIcon from './assets/icons/linkedin.svg';

function About() {
    const { language } = useLanguage();

    return (
        <div className="about-container">
            <div className="about-info">
                <img src="/images/mijn-foto.jpg" alt="Jouw Naam" className="about-photo" />
                <div className="about-text">
                    <h2 className="about-title">{language === 'nl' ? 'Over Mij' : 'About Me'}</h2>
                    <div className="about-paragraph">
                        {language === 'nl'
                            ? 'Hallo! Mijn naam is Valentino Dos Santos. Ik ben een gepassioneerde webdeveloper met een drive om dynamische, gebruiksvriendelijke websites en applicaties te creëren. Mijn reis in de technologie komt voort uit mijn liefde voor continu leren en probleemoplossing.'
                            : 'Hello, My name is Valentino Dos Santos, a passionate web developer with a drive for creating dynamic, user-friendly websites and applications. My journey into technology comes from my love for continuous learning and problem-solving.'}
                    </div>
                    <div className="about-paragraph">
                        {language === 'nl'
                            ? 'Ik ben vastbesloten om niet alleen te groeien in coderen, maar ook in kennis, doel en het leven. Webontwikkeling is mijn ambacht, en ik streef ernaar om innovatieve oplossingen te creëren die zowel functioneel als intuïtief zijn. Wanneer ik niet aan het coderen ben, verken ik nieuwe culturen, reis ik de wereld rond en verbind ik me met mensen uit verschillende achtergronden, wat mijn creativiteit voedt.'
                            : 'I’m dedicated to growing not only in coding but also in knowledge, purpose, and life. Web development is my craft, and I strive to create innovative solutions that are both functional and intuitive. When I’m not coding, I’m exploring new cultures, traveling the world, and connecting with people from diverse backgrounds, which fuels my creativity.'}
                    </div>
                    <div className="about-paragraph">
                        {language === 'nl'
                            ? 'Laten we samen iets geweldigs bouwen!'
                            : 'Let’s build something amazing together!'}
                    </div>
                    {/* Voeg hier de iconen toe */}
                    <div className="social-icons">
                        <a href="https://www.facebook.com/valentino.dossantos.7" target="_blank" rel="noopener noreferrer">
                            <img src={FacebookIcon} alt="Facebook" className="social-icon" />
                        </a>
                        <a href="https://www.instagram.com/mightylion23" target="_blank" rel="noopener noreferrer">
                            <img src={InstagramIcon} alt="Instagram" className="social-icon" />
                        </a>
                        <a href="https://www.linkedin.com/in/valentino-dos-santos-52044b234/" target="_blank" rel="noopener noreferrer">
                            <img src={LinkedInIcon} alt="LinkedIn" className="social-icon" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
